__turbopack_context__.v({
  "addKeywordsBadge": "_5Nf9sa_addKeywordsBadge",
  "alertButton": "_5Nf9sa_alertButton",
  "alertMessageText": "_5Nf9sa_alertMessageText",
  "badge": "_5Nf9sa_badge",
  "badgesWrapper": "_5Nf9sa_badgesWrapper",
  "calendarIconWrapper": "_5Nf9sa_calendarIconWrapper",
  "col": "_5Nf9sa_col",
  "description": "_5Nf9sa_description",
  "detailItem": "_5Nf9sa_detailItem",
  "detailText": "_5Nf9sa_detailText",
  "detailTitle": "_5Nf9sa_detailTitle",
  "details": "_5Nf9sa_details",
  "emptyState": "_5Nf9sa_emptyState",
  "emptyText": "_5Nf9sa_emptyText",
  "incompleteStripAlert": "_5Nf9sa_incompleteStripAlert",
  "keywordsLabel": "_5Nf9sa_keywordsLabel",
  "keywordsWrapper": "_5Nf9sa_keywordsWrapper",
  "linkBtn": "_5Nf9sa_linkBtn",
  "missingData": "_5Nf9sa_missingData",
  "officeHoursSection": "_5Nf9sa_officeHoursSection",
  "primaryButton": "_5Nf9sa_primaryButton",
  "primaryButtonWrapper": "_5Nf9sa_primaryButtonWrapper",
  "root": "_5Nf9sa_root",
  "setupPrompt": "_5Nf9sa_setupPrompt",
  "subTitle": "_5Nf9sa_subTitle",
  "subtext": "_5Nf9sa_subtext",
  "titleHintLabel": "_5Nf9sa_titleHintLabel",
  "warningMessageText": "_5Nf9sa_warningMessageText",
});
